import http from "./http";
import apis from "../config/apis.json";

const api = 
    process.env.REACT_APP_ENVIRON === "development"
    ? apis.dev
    : process.env.REACT_APP_ENVIRON === "production"
    ? apis.prod
    : apis.test;

// Create a new thread on the server
export async function createThread(organizationId, threadData) {
    const response = await http.post(`${api}/api/thread/${organizationId}`, threadData);
    return response;
}

// Get all threads for a user in an organization
// Supports optional pagination params (forward-compatible with server pagination)
export async function getThreads(organizationId, options = {}) {
    const { page = 1, limit = 20 } = options;
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    
    const response = await http.get(`${api}/api/thread/${organizationId}?${params.toString()}`);
    return response;
}

// Get a specific thread by thread_id
export async function getThreadById(organizationId, threadId) {
    const response = await http.get(`${api}/api/thread/${organizationId}/${threadId}`);
    return response;
}

// Update a thread (e.g., when thread_id is created by LangGraph)
export async function updateThread(organizationId, threadId, updateData) {
    const response = await http.put(`${api}/api/thread/${organizationId}/${threadId}`, updateData);
    return response;
}

// Delete a thread
export async function deleteThread(organizationId, threadId) {
    const response = await http.delete(`${api}/api/thread/${organizationId}/${threadId}`);
    return response;
}
